import { createSlice } from '@reduxjs/toolkit';
import { customersData } from '../../data/customersData';

const initialState = {
  customers: customersData,
  loading: false,
  error: null,
  searchTerm: '',
  selectedCustomer: null,
};

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    updateCustomer: (state, action) => {
      const index = state.customers.findIndex(customer => customer.id === action.payload.id);
      if (index !== -1) {
        state.customers[index] = action.payload;
      }
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setCustomers,
  updateCustomer,
  setSearchTerm,
  setSelectedCustomer,
  setLoading,
  setError,
} = customersSlice.actions;

export default customersSlice.reducer;